/** @format */
import { useContext, useState } from 'react';

import { getProductSummary } from '@toucan/services/requests/products';
import { getModelStockInfo } from '@toucan/services/requests/search';

import { MarketContext } from '@toucan/client/global/market';
import { ProductSummaryV2 } from '@toucan/client/global/product';
import { ModelStockInfo } from '@toucan/common/services/search/types';

type UseProductDataProps = {
    initialProductInfo: ProductSummaryV2;
    initialStockInfo: ModelStockInfo | null;
};

export const useProductData = ({
    initialProductInfo,
    initialStockInfo,
}: UseProductDataProps) => {
    const { activeMarket } = useContext(MarketContext);
    const [productInfo, setProductInfo] = useState(initialProductInfo);
    const [stockInfo, setStockInfo] = useState(initialStockInfo);

    const refreshProductData = async (productId: number) => {
        const productInfo = await getProductSummary(
            productId,
            activeMarket.code
        );
        const stockInfo = productInfo.isSold
            ? await getModelStockInfo(
                  productInfo.modelId.toString(),
                  activeMarket,
                  productInfo.id
              )
            : null;

        setProductInfo(productInfo);
        setStockInfo(stockInfo);

        return productInfo;
    };

    return { productInfo, stockInfo, refreshProductData };
};
